import {useQuery} from "@tanstack/react-query";
import * as api from "../../api";

const defaultStaleTime = 1000 * 60 * 24 * 7; // a week

export const useGeoJSONStations = (stationFilter, props={}) => {
    return useQuery({
        queryKey: ['geo', 'stations', stationFilter],
        queryFn: () => api.Geo.getStations(stationFilter),
        keepPreviousData: true,
        staleTime: defaultStaleTime,
        ...props
    });
}

export const useGeoJSONModel1Stations = (model1Filter, props={}) => {
    return useQuery({
        queryKey: ['geo', 'model1Stations', model1Filter],
        queryFn: () => api.Geo.getModel1Stations(model1Filter),
        keepPreviousData: true,
        staleTime: defaultStaleTime,
        ...props
    });
}

export const useGeoJSONModel23Stations = (model23Filter, props={}) => {
    return useQuery({
        queryKey: ['geo', 'model23Stations', model23Filter],
        queryFn: () => api.Geo.getModel23Stations(model23Filter),
        keepPreviousData: true,
        staleTime: defaultStaleTime,
        ...props
    });
}

export const useGeoJSONMicroZones = (microZoneFilter, props={}) => {
    return useQuery({
        queryKey: ['geo', 'microZones', microZoneFilter],
        queryFn: () => api.Geo.getMicroZones(microZoneFilter),
        keepPreviousData: true,
        staleTime: defaultStaleTime,
        ...props
    });
}

export const useGeoJSONMicroZonesModel1AggregatedData = (microZoneFilter, props={}) => {
    return useQuery({
        queryKey: ['geo', 'microZones', microZoneFilter],
        queryFn: () => api.Geo.getMicroZonesModel1AggregatedData(microZoneFilter),
        keepPreviousData: true,
        staleTime: defaultStaleTime,
        ...props
    });
}

export const useGeoJSONIncidents = (incidentsFilter, props={}) => {
    return useQuery({
        queryKey: ['geo', 'incidents', incidentsFilter],
        queryFn: () => api.Geo.getIncidents(incidentsFilter),
        keepPreviousData: true,
        staleTime: defaultStaleTime,
        ...props
    });
}


export const useGeoJSONModels23 = (models23Filter, props={}) => {
    return useQuery({
        queryKey: ['geo', 'models23', models23Filter],
        queryFn: () => api.Geo.getModels23(models23Filter),
        keepPreviousData: true,
        staleTime: defaultStaleTime,
        ...props
    });
}